import { DatePicker, type DatePickerProps } from "@mui/x-date-pickers";
import { ReactElement } from "react";

import { InputError } from "../../inputError";

export interface DatePickerWithErrorProps extends Omit<DatePickerProps, "sx"> {
  errorMsg?: string;
  datePickerSx?: DatePickerProps["sx"];
}

export const DatePickerWithError = ({ errorMsg, datePickerSx, ...props }: DatePickerWithErrorProps): ReactElement => {
  return (
    <>
      <DatePicker
        slotProps={{
          textField: {
            error: Boolean(errorMsg),
          },
        }}
        orientation="landscape"
        sx={datePickerSx}
        {...props}
      />
      {errorMsg && <InputError errorMsg={errorMsg} />}
    </>
  );
};
